import React, { useEffect } from "react";
import { GridStack } from "gridstack";

import { useTranslation } from "react-i18next";
import ViewBankDetails from "./ViewBank";
import DMSHeader from "../../../DMSHeader/DMSHeader";
import GridItem from "../../../../../Components/UiComponents/GridItem/GridItem";

// Component for rendering view bank details form
const ViewBankDetailsMain = () => {
  // Initialize translation hook for internationalization
  const { t } = useTranslation();

  // Initialize GridStack on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define grid layout configuration with header and main content
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Header component with title and navigation options
      component: (
        <DMSHeader
          title={t("View Bank Details")}
          fileName="DistrictWiseBranches"
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      // Main bank details view component
      component: <ViewBankDetails />,
    },
  ];

  // Render grid layout container with configured items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default ViewBankDetailsMain;
